{
  "schemaVersion": 1,
  "characters": {
    "m": {
      "handclip": [
        "/game/characters/feedback/m/frame-13.png",
        "/game/characters/feedback/m/frame-13.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-15.png",
        "/game/characters/feedback/m/frame-15.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-13.png",
        "/game/characters/feedback/m/frame-13.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-15.png",
        "/game/characters/feedback/m/frame-15.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-13.png",
        "/game/characters/feedback/m/frame-13.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-15.png",
        "/game/characters/feedback/m/frame-15.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-13.png",
        "/game/characters/feedback/m/frame-13.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-15.png",
        "/game/characters/feedback/m/frame-15.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-13.png",
        "/game/characters/feedback/m/frame-13.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-15.png",
        "/game/characters/feedback/m/frame-15.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-13.png",
        "/game/characters/feedback/m/frame-13.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-15.png",
        "/game/characters/feedback/m/frame-15.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-14.png",
        "/game/characters/feedback/m/frame-13.png",
        "/game/characters/feedback/m/frame-13.png"
      ],
      "cry": [
        "/game/characters/feedback/m/frame-16.png",
        "/game/characters/feedback/m/frame-16.png",
        "/game/characters/feedback/m/frame-17.png",
        "/game/characters/feedback/m/frame-17.png",
        "/game/characters/feedback/m/frame-18.png",
        "/game/characters/feedback/m/frame-18.png",
        "/game/characters/feedback/m/frame-16.png",
        "/game/characters/feedback/m/frame-16.png",
        "/game/characters/feedback/m/frame-17.png",
        "/game/characters/feedback/m/frame-17.png",
        "/game/characters/feedback/m/frame-18.png",
        "/game/characters/feedback/m/frame-18.png",
        "/game/characters/feedback/m/frame-16.png",
        "/game/characters/feedback/m/frame-16.png",
        "/game/characters/feedback/m/frame-17.png",
        "/game/characters/feedback/m/frame-17.png",
        "/game/characters/feedback/m/frame-18.png",
        "/game/characters/feedback/m/frame-18.png",
        "/game/characters/feedback/m/frame-16.png",
        "/game/characters/feedback/m/frame-16.png",
        "/game/characters/feedback/m/frame-17.png",
        "/game/characters/feedback/m/frame-17.png",
        "/game/characters/feedback/m/frame-18.png",
        "/game/characters/feedback/m/frame-18.png",
        "/game/characters/feedback/m/frame-16.png",
        "/game/characters/feedback/m/frame-16.png",
        "/game/characters/feedback/m/frame-17.png",
        "/game/characters/feedback/m/frame-17.png",
        "/game/characters/feedback/m/frame-18.png",
        "/game/characters/feedback/m/frame-18.png"
      ],
      "hit": [
        "/game/characters/feedback/m/frame-12.png",
        "/game/characters/feedback/m/frame-12.png",
        "/game/characters/feedback/m/frame-24.png",
        "/game/characters/feedback/m/frame-24.png",
        "/game/characters/feedback/m/frame-24.png",
        "/game/characters/feedback/m/frame-24.png",
        "/game/characters/feedback/m/frame-24.png",
        "/game/characters/feedback/m/frame-24.png",
        "/game/characters/feedback/m/frame-24.png",
        "/game/characters/feedback/m/frame-24.png",
        "/game/characters/feedback/m/frame-25.png",
        "/game/characters/feedback/m/frame-25.png",
        "/game/characters/feedback/m/frame-38.png",
        "/game/characters/feedback/m/frame-38.png",
        "/game/characters/feedback/m/frame-38.png",
        "/game/characters/feedback/m/frame-38.png",
        "/game/characters/feedback/m/frame-11.png",
        "/game/characters/feedback/m/frame-11.png",
        "/game/characters/feedback/m/frame-11.png",
        "/game/characters/feedback/m/frame-11.png"
      ],
      "animationTimelines": {
        "handclip": {
          "frameRate": 25,
          "sourceFrames": [
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13
          ],
          "faceSourceFrames": [
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13
          ],
          "upperSourceFrames": [
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13
          ],
          "durationMs": 2000,
          "loop": false,
          "stopAtEnd": false
        },
        "cry": {
          "frameRate": 25,
          "sourceFrames": [
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18
          ],
          "faceSourceFrames": [
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18
          ],
          "upperSourceFrames": [
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18
          ],
          "durationMs": 1200,
          "loop": false,
          "stopAtEnd": false
        },
        "hit": {
          "frameRate": 25,
          "sourceFrames": [
            12,
            12,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            38,
            38,
            38,
            38,
            11,
            11,
            11,
            11
          ],
          "faceSourceFrames": [
            12,
            12,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            38,
            38,
            38,
            38,
            11,
            11,
            11,
            11
          ],
          "upperSourceFrames": [
            12,
            12,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            38,
            38,
            38,
            38,
            11,
            11,
            11,
            11
          ],
          "durationMs": 800,
          "loop": false,
          "stopAtEnd": false
        }
      },
      "width": 114,
      "height": 95,
      "anchor": {
        "x": 62,
        "y": 83
      },
      "layerGroups": {
        "face": [
          "face"
        ],
        "faceUp": [
          "hair",
          "cloth",
          "eff",
          "head",
          "glass"
        ],
        "weaponRenderedSeparately": true
      }
    },
    "f": {
      "handclip": [
        "/game/characters/feedback/f/frame-13.png",
        "/game/characters/feedback/f/frame-13.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-15.png",
        "/game/characters/feedback/f/frame-15.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-13.png",
        "/game/characters/feedback/f/frame-13.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-15.png",
        "/game/characters/feedback/f/frame-15.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-13.png",
        "/game/characters/feedback/f/frame-13.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-15.png",
        "/game/characters/feedback/f/frame-15.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-13.png",
        "/game/characters/feedback/f/frame-13.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-15.png",
        "/game/characters/feedback/f/frame-15.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-13.png",
        "/game/characters/feedback/f/frame-13.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-15.png",
        "/game/characters/feedback/f/frame-15.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-13.png",
        "/game/characters/feedback/f/frame-13.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-15.png",
        "/game/characters/feedback/f/frame-15.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-14.png",
        "/game/characters/feedback/f/frame-13.png",
        "/game/characters/feedback/f/frame-13.png"
      ],
      "cry": [
        "/game/characters/feedback/f/frame-16.png",
        "/game/characters/feedback/f/frame-16.png",
        "/game/characters/feedback/f/frame-17.png",
        "/game/characters/feedback/f/frame-17.png",
        "/game/characters/feedback/f/frame-18.png",
        "/game/characters/feedback/f/frame-18.png",
        "/game/characters/feedback/f/frame-16.png",
        "/game/characters/feedback/f/frame-16.png",
        "/game/characters/feedback/f/frame-17.png",
        "/game/characters/feedback/f/frame-17.png",
        "/game/characters/feedback/f/frame-18.png",
        "/game/characters/feedback/f/frame-18.png",
        "/game/characters/feedback/f/frame-16.png",
        "/game/characters/feedback/f/frame-16.png",
        "/game/characters/feedback/f/frame-17.png",
        "/game/characters/feedback/f/frame-17.png",
        "/game/characters/feedback/f/frame-18.png",
        "/game/characters/feedback/f/frame-18.png",
        "/game/characters/feedback/f/frame-16.png",
        "/game/characters/feedback/f/frame-16.png",
        "/game/characters/feedback/f/frame-17.png",
        "/game/characters/feedback/f/frame-17.png",
        "/game/characters/feedback/f/frame-18.png",
        "/game/characters/feedback/f/frame-18.png",
        "/game/characters/feedback/f/frame-16.png",
        "/game/characters/feedback/f/frame-16.png",
        "/game/characters/feedback/f/frame-17.png",
        "/game/characters/feedback/f/frame-17.png",
        "/game/characters/feedback/f/frame-18.png",
        "/game/characters/feedback/f/frame-18.png"
      ],
      "hit": [
        "/game/characters/feedback/f/frame-12.png",
        "/game/characters/feedback/f/frame-12.png",
        "/game/characters/feedback/f/frame-24.png",
        "/game/characters/feedback/f/frame-24.png",
        "/game/characters/feedback/f/frame-24.png",
        "/game/characters/feedback/f/frame-24.png",
        "/game/characters/feedback/f/frame-24.png",
        "/game/characters/feedback/f/frame-24.png",
        "/game/characters/feedback/f/frame-24.png",
        "/game/characters/feedback/f/frame-24.png",
        "/game/characters/feedback/f/frame-25.png",
        "/game/characters/feedback/f/frame-25.png",
        "/game/characters/feedback/f/frame-38.png",
        "/game/characters/feedback/f/frame-38.png",
        "/game/characters/feedback/f/frame-38.png",
        "/game/characters/feedback/f/frame-38.png",
        "/game/characters/feedback/f/frame-11.png",
        "/game/characters/feedback/f/frame-11.png",
        "/game/characters/feedback/f/frame-11.png",
        "/game/characters/feedback/f/frame-11.png"
      ],
      "animationTimelines": {
        "handclip": {
          "frameRate": 25,
          "sourceFrames": [
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13
          ],
          "faceSourceFrames": [
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13
          ],
          "upperSourceFrames": [
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13,
            14,
            14,
            15,
            15,
            14,
            14,
            13,
            13
          ],
          "durationMs": 2000,
          "loop": false,
          "stopAtEnd": false
        },
        "cry": {
          "frameRate": 25,
          "sourceFrames": [
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18
          ],
          "faceSourceFrames": [
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18
          ],
          "upperSourceFrames": [
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18,
            16,
            16,
            17,
            17,
            18,
            18
          ],
          "durationMs": 1200,
          "loop": false,
          "stopAtEnd": false
        },
        "hit": {
          "frameRate": 25,
          "sourceFrames": [
            12,
            12,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            38,
            38,
            38,
            38,
            11,
            11,
            11,
            11
          ],
          "faceSourceFrames": [
            12,
            12,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            38,
            38,
            38,
            38,
            11,
            11,
            11,
            11
          ],
          "upperSourceFrames": [
            12,
            12,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            38,
            38,
            38,
            38,
            11,
            11,
            11,
            11
          ],
          "durationMs": 800,
          "loop": false,
          "stopAtEnd": false
        }
      },
      "width": 114,
      "height": 95,
      "anchor": {
        "x": 62,
        "y": 83
      },
      "layerGroups": {
        "face": [
          "face"
        ],
        "faceUp": [
          "hair",
          "cloth",
          "eff",
          "head",
          "glass"
        ],
        "weaponRenderedSeparately": true
      }
    }
  },
  "effects": {
    "propAura": {
      "path": "/game/characters/feedback-effects/propAura/frame-00.png",
      "frames": [
        "/game/characters/feedback-effects/propAura/frame-00.png",
        "/game/characters/feedback-effects/propAura/frame-01.png",
        "/game/characters/feedback-effects/propAura/frame-01.png",
        "/game/characters/feedback-effects/propAura/frame-01.png",
        "/game/characters/feedback-effects/propAura/frame-04.png",
        "/game/characters/feedback-effects/propAura/frame-05.png",
        "/game/characters/feedback-effects/propAura/frame-06.png",
        "/game/characters/feedback-effects/propAura/frame-07.png",
        "/game/characters/feedback-effects/propAura/frame-08.png",
        "/game/characters/feedback-effects/propAura/frame-09.png",
        "/game/characters/feedback-effects/propAura/frame-10.png",
        "/game/characters/feedback-effects/propAura/frame-11.png",
        "/game/characters/feedback-effects/propAura/frame-12.png",
        "/game/characters/feedback-effects/propAura/frame-13.png",
        "/game/characters/feedback-effects/propAura/frame-14.png",
        "/game/characters/feedback-effects/propAura/frame-15.png",
        "/game/characters/feedback-effects/propAura/frame-16.png",
        "/game/characters/feedback-effects/propAura/frame-17.png",
        "/game/characters/feedback-effects/propAura/frame-18.png",
        "/game/characters/feedback-effects/propAura/frame-19.png",
        "/game/characters/feedback-effects/propAura/frame-19.png",
        "/game/characters/feedback-effects/propAura/frame-18.png",
        "/game/characters/feedback-effects/propAura/frame-19.png",
        "/game/characters/feedback-effects/propAura/frame-19.png",
        "/game/characters/feedback-effects/propAura/frame-18.png",
        "/game/characters/feedback-effects/propAura/frame-19.png",
        "/game/characters/feedback-effects/propAura/frame-19.png",
        "/game/characters/feedback-effects/propAura/frame-18.png",
        "/game/characters/feedback-effects/propAura/frame-19.png",
        "/game/characters/feedback-effects/propAura/frame-19.png",
        "/game/characters/feedback-effects/propAura/frame-30.png",
        "/game/characters/feedback-effects/propAura/frame-31.png",
        "/game/characters/feedback-effects/propAura/frame-31.png",
        "/game/characters/feedback-effects/propAura/frame-30.png",
        "/game/characters/feedback-effects/propAura/frame-31.png",
        "/game/characters/feedback-effects/propAura/frame-31.png",
        "/game/characters/feedback-effects/propAura/frame-30.png",
        "/game/characters/feedback-effects/propAura/frame-31.png",
        "/game/characters/feedback-effects/propAura/frame-31.png",
        "/game/characters/feedback-effects/propAura/frame-30.png",
        "/game/characters/feedback-effects/propAura/frame-31.png",
        "/game/characters/feedback-effects/propAura/frame-31.png",
        "/game/characters/feedback-effects/propAura/frame-30.png",
        "/game/characters/feedback-effects/propAura/frame-31.png",
        "/game/characters/feedback-effects/propAura/frame-31.png",
        "/game/characters/feedback-effects/propAura/frame-45.png",
        "/game/characters/feedback-effects/propAura/frame-46.png",
        "/game/characters/feedback-effects/propAura/frame-47.png",
        "/game/characters/feedback-effects/propAura/frame-48.png",
        "/game/characters/feedback-effects/propAura/frame-49.png",
        "/game/characters/feedback-effects/propAura/frame-50.png",
        "/game/characters/feedback-effects/propAura/frame-00.png"
      ],
      "width": 234,
      "height": 278,
      "anchor": {
        "x": 117,
        "y": 177
      },
      "frameRate": 25,
      "sha256": [
        "78df93b1339d2c9fbbafa7508cfaf38ac1558097e970b7f81c010f5db8130b77",
        "78df93b1339d2c9fbbafa7508cfaf38ac1558097e970b7f81c010f5db8130b77",
        "78df93b1339d2c9fbbafa7508cfaf38ac1558097e970b7f81c010f5db8130b77",
        "78df93b1339d2c9fbbafa7508cfaf38ac1558097e970b7f81c010f5db8130b77",
        "52cbd0a726b1adaf8e766e4f708a931a571eb23b11f6bbea1440c9ceaa19e6f1",
        "74d828c0fcad66db3e7ead37cc0e4dcb6a5b7aa2556bc45342cb2fbcb9420319",
        "0fc3f89c3e6201c41d8a880c8bc58ab66211e8ae2c6bdd2311f5e9840e124683",
        "cd1e7a41cb157da6c3b9aacdf02bf9539181e67925ce00d1e6ab952af1d527f8",
        "cb09762c8b47587145bb4911c2525635e994d3235bab35b1f1c9e0b5e7395033",
        "d0ed279b16e9b63b26889392ca9b3a793822f075cfeab5d3891ae7d349ea379f",
        "e2ed3e701780f0d51d0c204df98bd1bd916fc1609f703488057419d1938667ca",
        "0e38b4a70cd3835d3f225172573f19732e7ab86ca9b48f5d93badbca535c6f54",
        "901bc609af9ead04aab5f1e265e3e973053e4c17ee3123bed546b66333506e91",
        "eab3175be8dac724b317e8eba6d1d3e513311edc872c0d1dd07dade433de96e1",
        "30fb9548917e04f8115e285516acdb07ca17c5cf6c1e48652c64ec598d1f4508",
        "dbbfaf4b610978a41ff2c406770f0544687ace65005fae1a091f78819b47d7f9",
        "4f2d82d04d065d7cd6e045425bc737b954ca9f5d6b691a4d69725bf449735d4f",
        "3214da57208d04e1a224c5e24cd7b64fb68c275a71fe521b50a8894cd6949bc3",
        "231e7b111fbb2d22b050ea65d8de3f34cf94606330677e69e7c2444737023bd7",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "231e7b111fbb2d22b050ea65d8de3f34cf94606330677e69e7c2444737023bd7",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "231e7b111fbb2d22b050ea65d8de3f34cf94606330677e69e7c2444737023bd7",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "231e7b111fbb2d22b050ea65d8de3f34cf94606330677e69e7c2444737023bd7",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "231e7b111fbb2d22b050ea65d8de3f34cf94606330677e69e7c2444737023bd7",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "231e7b111fbb2d22b050ea65d8de3f34cf94606330677e69e7c2444737023bd7",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "231e7b111fbb2d22b050ea65d8de3f34cf94606330677e69e7c2444737023bd7",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "231e7b111fbb2d22b050ea65d8de3f34cf94606330677e69e7c2444737023bd7",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "231e7b111fbb2d22b050ea65d8de3f34cf94606330677e69e7c2444737023bd7",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "cf279bfca3615ee797168907e43c1a7117903beefcb26e19d2eb81788799a1b0",
        "231e7b111fbb2d22b050ea65d8de3f34cf94606330677e69e7c2444737023bd7",
        "a2ca77c402bf8c8c34df9a4449b6cfaec7b34d7bccb7fa5c651701caa4a88a68",
        "220d60ad215748a4d21c256696cf804be8704e1f11b39b6da1685f0dab70d1cf",
        "48ede4979f4fab0af146060865921551baf91a544ac2fdef9928fc1e73cddbdd",
        "986df8c164ce404ccbf3ef5c9ac40e1649f806ebf72983fdddb3d13193dbda64",
        "78df93b1339d2c9fbbafa7508cfaf38ac1558097e970b7f81c010f5db8130b77",
        "78df93b1339d2c9fbbafa7508cfaf38ac1558097e970b7f81c010f5db8130b77"
      ],
      "sourceCharacterId": 455,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameii.swf",
      "sourceSha256": "a3a4343d1ac15e9df64051b330ec8646f2b50d851a0c76c5050fbca510178504",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.game.ghostPcikPropAsset",
      "position": {
        "x": 0,
        "y": -10
      },
      "sourceFileFrameRate": 24,
      "loop": false,
      "headIconAtSourceFrame": 12,
      "headIconPosition": {
        "x": -5,
        "y": -140
      },
      "vectorFrameSha256": [
        "d36459965f1ca7b3b21f5b89b0ae127c41800ee3d79160e49d3f33fd3592bd89",
        "9544d5c01ea4ff3d52dcee06622aa7e85cfecc23744ba3706c69007dd4247027",
        "9544d5c01ea4ff3d52dcee06622aa7e85cfecc23744ba3706c69007dd4247027",
        "9544d5c01ea4ff3d52dcee06622aa7e85cfecc23744ba3706c69007dd4247027",
        "81c45e1b7b72195bb65f6fc0bdea827b26c78aae82b5bb87fb530dd3a3c99d43",
        "c05d94d6097d41bfb9b7d1e37df113a8122e4f149bf18ee9f8b68c2af81686ed",
        "411efbda9837e7cf701bdc0e9eaa2a94ba9214b08d3f0f17cdd1febaa5a52a25",
        "37f11a8a0f8e0673641ea33ddbf2fe9c9355a0c06bc71e8d12515ea2b0432daa",
        "434d1f5774c21fd5643a33c360942882f460c3d3873ec8568587376f329123c3",
        "bf53fa026e20e76d0f10f4862f1481d878cec7aa1846ec438ea625739928ca17",
        "a68cbe3377941f2a9e33eb9b8803575a542cce73c5505385f350b7b543e2f12f",
        "0e0bc7d3c54628079f83faa2b1921094f84caf63c3fda3e43d6d83c5fd553125",
        "86043c4a951f36431f7db2ff11bbdaf2fc2822e2278f921ac98dbe22ea081c8d",
        "3a3a2b41d81c8baddf44734b260ecbae73c0b94d9e0d2d4034615dcbcba7eca4",
        "07bf75891fed16bf108def06b2b9824269a60feca5ab16dd98757c067b9bad91",
        "5c964996bdc444799b971ecb387047a7382b96695af4a129ab9d4eca3bf96761",
        "bfdcda4470d0b894e4c0b48644b8ef358f1ca5c8b83e80f775d0df2ff96e928c",
        "ef2e3316140d3663f63303d9d1644efd008129189c32ec05e0499caf5bd6a64b",
        "214066a2d7172aef17af40b3ed91c59f51731442f033da043f13341013a8f92d",
        "667aa780da7b5648aff213c3d2e72f8d29d2eb06283414c47cce558f93045cd4",
        "667aa780da7b5648aff213c3d2e72f8d29d2eb06283414c47cce558f93045cd4",
        "214066a2d7172aef17af40b3ed91c59f51731442f033da043f13341013a8f92d",
        "667aa780da7b5648aff213c3d2e72f8d29d2eb06283414c47cce558f93045cd4",
        "667aa780da7b5648aff213c3d2e72f8d29d2eb06283414c47cce558f93045cd4",
        "214066a2d7172aef17af40b3ed91c59f51731442f033da043f13341013a8f92d",
        "667aa780da7b5648aff213c3d2e72f8d29d2eb06283414c47cce558f93045cd4",
        "667aa780da7b5648aff213c3d2e72f8d29d2eb06283414c47cce558f93045cd4",
        "214066a2d7172aef17af40b3ed91c59f51731442f033da043f13341013a8f92d",
        "667aa780da7b5648aff213c3d2e72f8d29d2eb06283414c47cce558f93045cd4",
        "667aa780da7b5648aff213c3d2e72f8d29d2eb06283414c47cce558f93045cd4",
        "f3b923178a091c12a8c7d74c48d17b92bcf99b20089ae473fbb905d15a5862d2",
        "ac91f3867fe4360032414f26def13747bdf907602a6500d68190bb1439d50209",
        "ac91f3867fe4360032414f26def13747bdf907602a6500d68190bb1439d50209",
        "f3b923178a091c12a8c7d74c48d17b92bcf99b20089ae473fbb905d15a5862d2",
        "ac91f3867fe4360032414f26def13747bdf907602a6500d68190bb1439d50209",
        "ac91f3867fe4360032414f26def13747bdf907602a6500d68190bb1439d50209",
        "f3b923178a091c12a8c7d74c48d17b92bcf99b20089ae473fbb905d15a5862d2",
        "ac91f3867fe4360032414f26def13747bdf907602a6500d68190bb1439d50209",
        "ac91f3867fe4360032414f26def13747bdf907602a6500d68190bb1439d50209",
        "f3b923178a091c12a8c7d74c48d17b92bcf99b20089ae473fbb905d15a5862d2",
        "ac91f3867fe4360032414f26def13747bdf907602a6500d68190bb1439d50209",
        "ac91f3867fe4360032414f26def13747bdf907602a6500d68190bb1439d50209",
        "f3b923178a091c12a8c7d74c48d17b92bcf99b20089ae473fbb905d15a5862d2",
        "ac91f3867fe4360032414f26def13747bdf907602a6500d68190bb1439d50209",
        "ac91f3867fe4360032414f26def13747bdf907602a6500d68190bb1439d50209",
        "a973bd2168e6e0e4937a764db703da38ee34f1de2321781c0e985922320c279a",
        "ef24ca2359c1441eaf359831fe2896ffe098d6be61df6431c97a467d151b6232",
        "f9d38b38a2ee24bf55e05e67198d75a728a19ae1560a1a9006a9350b25485e6b",
        "b0260d8dd01ef7d2ed91562ffae802a02555b34aea8094091bfba721d634f1ee",
        "3ed588af35616a9482c81eb1a6d056fc0b13c31c1d4922a56ce318c96509437d",
        "abd15fa7bc6e293d4163ed1c7516d81f83f4d320567aeefcbf1c9a70cd1063b6",
        "d36459965f1ca7b3b21f5b89b0ae127c41800ee3d79160e49d3f33fd3592bd89"
      ]
    },
    "powReadyAura": {
      "path": "/game/characters/feedback-effects/powReadyAura/frame-00.png",
      "frames": [
        "/game/characters/feedback-effects/powReadyAura/frame-00.png",
        "/game/characters/feedback-effects/powReadyAura/frame-01.png",
        "/game/characters/feedback-effects/powReadyAura/frame-02.png",
        "/game/characters/feedback-effects/powReadyAura/frame-03.png",
        "/game/characters/feedback-effects/powReadyAura/frame-04.png"
      ],
      "width": 121,
      "height": 101,
      "anchor": {
        "x": 59,
        "y": 84
      },
      "frameRate": 25,
      "sha256": [
        "244e6db3679a749b53cc559a316bba6a70020db6a05b50148eebcf5ceda54afc",
        "420e5b14bee299b72d016da193c260ac71fe90a05c08fc3a8c8e68969f81b581",
        "3e0329f434afc8ed8d486eb063ef92ef3f950a0dd7dcddf31b6424023b5af54d",
        "81793d8f5d191879e59940b5db46353c1a4e0fd71bb0f30da3d56892ac7a9dbd",
        "80818bda4c892f45147dd062aab03cc5ab7305945dbfd2ea04e57892ab93184d"
      ],
      "sourceCharacterId": 516,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameii.swf",
      "sourceSha256": "a3a4343d1ac15e9df64051b330ec8646f2b50d851a0c76c5050fbca510178504",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.game.danderAsset",
      "position": {
        "x": 3,
        "y": 5
      },
      "sourceFileFrameRate": 24,
      "loop": true,
      "headIconAtSourceFrame": null,
      "headIconPosition": null,
      "vectorFrameSha256": [
        "9236d36c6804f47bed6113a74073029127e3231002033bfb83da3d9155ca1c4c",
        "49d3812d8135e91406c3e260856d8d37394444f303a97c4def14b9bff73969ae",
        "212dc4d96b18c5659d4b6e56a8c2be741dac1afa377916781c6108cfde1f1a85",
        "716fa7fe3fda69a4bf02f9fa4e4852bea319b54dc8d58a9c3b094cc533d3e5e9",
        "3ed6a58c82ff26d4b1b36f4225038e91b9d24f79d8eb78d74ddec1ac4202fc8b"
      ]
    },
    "frozenBlock": {
      "path": "/game/characters/feedback-effects/frozenBlock/frame-00.png",
      "frames": [
        "/game/characters/feedback-effects/frozenBlock/frame-00.png",
        "/game/characters/feedback-effects/frozenBlock/frame-01.png",
        "/game/characters/feedback-effects/frozenBlock/frame-02.png",
        "/game/characters/feedback-effects/frozenBlock/frame-03.png",
        "/game/characters/feedback-effects/frozenBlock/frame-04.png",
        "/game/characters/feedback-effects/frozenBlock/frame-05.png",
        "/game/characters/feedback-effects/frozenBlock/frame-06.png",
        "/game/characters/feedback-effects/frozenBlock/frame-07.png",
        "/game/characters/feedback-effects/frozenBlock/frame-08.png",
        "/game/characters/feedback-effects/frozenBlock/frame-09.png",
        "/game/characters/feedback-effects/frozenBlock/frame-10.png",
        "/game/characters/feedback-effects/frozenBlock/frame-11.png",
        "/game/characters/feedback-effects/frozenBlock/frame-12.png",
        "/game/characters/feedback-effects/frozenBlock/frame-13.png",
        "/game/characters/feedback-effects/frozenBlock/frame-14.png",
        "/game/characters/feedback-effects/frozenBlock/frame-15.png",
        "/game/characters/feedback-effects/frozenBlock/frame-16.png",
        "/game/characters/feedback-effects/frozenBlock/frame-17.png",
        "/game/characters/feedback-effects/frozenBlock/frame-18.png",
        "/game/characters/feedback-effects/frozenBlock/frame-19.png",
        "/game/characters/feedback-effects/frozenBlock/frame-20.png",
        "/game/characters/feedback-effects/frozenBlock/frame-21.png",
        "/game/characters/feedback-effects/frozenBlock/frame-22.png",
        "/game/characters/feedback-effects/frozenBlock/frame-23.png",
        "/game/characters/feedback-effects/frozenBlock/frame-24.png",
        "/game/characters/feedback-effects/frozenBlock/frame-25.png",
        "/game/characters/feedback-effects/frozenBlock/frame-26.png",
        "/game/characters/feedback-effects/frozenBlock/frame-27.png",
        "/game/characters/feedback-effects/frozenBlock/frame-28.png",
        "/game/characters/feedback-effects/frozenBlock/frame-29.png",
        "/game/characters/feedback-effects/frozenBlock/frame-30.png",
        "/game/characters/feedback-effects/frozenBlock/frame-31.png",
        "/game/characters/feedback-effects/frozenBlock/frame-32.png",
        "/game/characters/feedback-effects/frozenBlock/frame-33.png",
        "/game/characters/feedback-effects/frozenBlock/frame-34.png",
        "/game/characters/feedback-effects/frozenBlock/frame-35.png",
        "/game/characters/feedback-effects/frozenBlock/frame-36.png",
        "/game/characters/feedback-effects/frozenBlock/frame-37.png",
        "/game/characters/feedback-effects/frozenBlock/frame-38.png",
        "/game/characters/feedback-effects/frozenBlock/frame-39.png",
        "/game/characters/feedback-effects/frozenBlock/frame-40.png",
        "/game/characters/feedback-effects/frozenBlock/frame-41.png",
        "/game/characters/feedback-effects/frozenBlock/frame-42.png",
        "/game/characters/feedback-effects/frozenBlock/frame-43.png",
        "/game/characters/feedback-effects/frozenBlock/frame-44.png",
        "/game/characters/feedback-effects/frozenBlock/frame-45.png",
        "/game/characters/feedback-effects/frozenBlock/frame-46.png",
        "/game/characters/feedback-effects/frozenBlock/frame-47.png",
        "/game/characters/feedback-effects/frozenBlock/frame-48.png",
        "/game/characters/feedback-effects/frozenBlock/frame-49.png",
        "/game/characters/feedback-effects/frozenBlock/frame-50.png",
        "/game/characters/feedback-effects/frozenBlock/frame-51.png",
        "/game/characters/feedback-effects/frozenBlock/frame-52.png",
        "/game/characters/feedback-effects/frozenBlock/frame-53.png",
        "/game/characters/feedback-effects/frozenBlock/frame-54.png",
        "/game/characters/feedback-effects/frozenBlock/frame-55.png",
        "/game/characters/feedback-effects/frozenBlock/frame-56.png",
        "/game/characters/feedback-effects/frozenBlock/frame-57.png",
        "/game/characters/feedback-effects/frozenBlock/frame-58.png",
        "/game/characters/feedback-effects/frozenBlock/frame-59.png",
        "/game/characters/feedback-effects/frozenBlock/frame-60.png",
        "/game/characters/feedback-effects/frozenBlock/frame-61.png",
        "/game/characters/feedback-effects/frozenBlock/frame-62.png",
        "/game/characters/feedback-effects/frozenBlock/frame-63.png",
        "/game/characters/feedback-effects/frozenBlock/frame-64.png",
        "/game/characters/feedback-effects/frozenBlock/frame-65.png",
        "/game/characters/feedback-effects/frozenBlock/frame-66.png"
      ],
      "width": 146,
      "height": 143,
      "anchor": {
        "x": 76,
        "y": 137
      },
      "frameRate": 25,
      "sha256": [
        "3c7b3a62071e538328c2ac217f0b42049c0996aeedc25958e79a4fef25736ad4",
        "39c60a92ede151ac6fa3bbd8ca95420804fc36310c7f677472ee02f620be229a",
        "6824081bf06b1fba1efb3c9e6c529dfe9f4028b0e50839736d842e3763e27ab0",
        "03eddf9b085db379e0d7db2bab25ed5c10c5f8cbc8e232336eec8c800b5619bc",
        "0ca4f4fdc311be8f8df455cad8ab52d8756c1c110b28dab5ae9511127bcf2e7f",
        "08b3e47049df350affddb9c55cc7f67bbe3e34629e7af2138773543ad1babb83",
        "017d6efadfc56d7eb9b78b72fe604afa9c7881200af51ac92f30589caa16e402",
        "8018319ab999e33ea95d8476e55c8c29daa9b2e0dd76272ddf35431bc6025919",
        "517125778d9a8808d1eb5b42bf88245ce34df06180e631abe71d7054154d5063",
        "671891e368f62f86ae8f8d118885dba405d4f71f88c5de697f47a715c51970a8",
        "4342349f8e677ca99b99ce09aea950a66ac5499554da1d823c0b1eba31e67652",
        "0bd30e268e4ba7a28e1dd2fd994f01e6fab2c32ee358eae11d44518ea516ced5",
        "1ed9d82bdf239a8979a84320163dcba1439ef6a8facd8d33ba289dd560683b26",
        "3e043a4b5c848ff7201967c65bd62f3ff05fb334a7a07f120e879a0bf695df44",
        "7fc7330516d4549cd575106fe0b46a1260cd798989c99c7ad89de3148623ff06",
        "989797ac43bab0f79b876a54c552148b449ed968a446d495f7091a8d79409b40",
        "9d51748225f28760706815fc163a764cedef554a7aadb1a6a22604b6fca26598",
        "534728e965e8d828579acd1c29b1b8dbc60dfe85a66fa2c36e972e2eb7341848",
        "f968da84e573c8ba3f5900891ba37c7099dfc3e04895b36c8ca4733ce127ecf8",
        "db582c68c42f9ae28fa00d4a6674e9918bec08691f29d576da44efd8122cb194",
        "88251406983bd29330d986a0e780d83566d5a00cafeea583c6dee0f0216f64ec",
        "bc6e5f43bc7c64ff261963781b571b49d373b700e40f965f4318f834c9dbd91a",
        "428e232a3ccdc0ae6663ce33d5e9ff253030ffe37488e1899197866772fa4fbf",
        "32481e6613b11992895032fc22d9e52356a55c22611834c1fac307bb3a27663b",
        "50b07771b85c06b7cf16ab7a2722d9eb3e8d74e14b237ede34a5dd10ac758ac6",
        "45d70f7422dcb4f148768fe9c75654b3908bba83d657dec8a8efba471d3d411f",
        "412182ed711e4ef1fa62721b2c20423644daddb3180c6704c1c65ee66d266103",
        "7e2538c0f6651da75c0fa03df85056ee8702cf8414eadb043b969512bd484040",
        "fa102745984e2050ba8a619399a58d4474884598c4300a345b5d48b62cd07c0f",
        "3fadc27294ee0c405ce3f377382dd1b60bad4c661a00378064d32153b0f90ad3",
        "ea5fef23569aaf411e73ca6ca9f60f0a7e44371347472fab4dca2ce0051d5c26",
        "15ac1493e5ec2bf31146de9ee678927144d85cd888add5f47f95261097e749f5",
        "1384fce585afaa2fc76eb38035af8c57a8c9ee0f9386b927b8e1083473800ba0",
        "e67c4543c2084ef56f265a45477b30fe4895f8a9462641561738a2c23979433e",
        "5037a01480b98ec0b96dccda8ee838ab109c2a19c7afbc168f046a12a83a92ac",
        "e298a20d10aae7e51ccc514438f69e5571753fed3ae68457080da520e55bb30e",
        "d6317d78fdde93f5b5401f27fb4d9ca1a13cd65c7a2b7fe025501b14914841e9",
        "56b7c86e9ca0c93e7766c2866cd0f1a35bee023548aa622854a66c82da1aca26",
        "6113a10fa8c0a38d8972063b33c681556773aad378a971a71f3f891ed1f872d6",
        "f04329afa8ab3260d322a8c0fccd9086a2fff193cd09bdbdda1cfdbe6a482a7b",
        "5073bdb1924847d6929c7127441f617fb99cd125a546335cb94bba27e0c8dee5",
        "1699ac1343882230b30a42feac0ff3234a4d992c026aec267e10538b70566065",
        "4c45a3a179790b04de2f2e06795bf1381a9166ef593d3c33c625d6554082faec",
        "2f89177c151bed4862a6392dc1395fcc88aad61eefbc576159c2e3c452dcc38f",
        "6e1bcab91e59fd068b4168065cf286008461af77d0b31a2c5b14d1a1f256137b",
        "6205f4579c6f1d8741176e7822e78b53d230a94c0c8dbde86a59a1cb96906404",
        "b553416bc62f8fe5c320bbda79c84a1bac7afce9b6381f2c6b40a346f8f737cc",
        "b7bbbd01d3fef35f1abe2ad6118d0172c1ff14cc868c2f738ea83b6885f86d03",
        "00ddd9de8f78ef7f1e720a211b84efabc56a0ae5e25a35df1801b16df272699a",
        "ac9f1b29ab3e146880e9e48bfef446af756830efcfea17ad64b4e3de3a193600",
        "5fc68f23955fbb505174ede0d8b786e9208d1b0fab0d5196e9e996f572c8e303",
        "6d6f1281dbc2cc88a457f697edf1cfefd3a65b6ce496bf39c063f0afd2142ce9",
        "e9904b81e3bc2789a3a6b33b4edddc5a2acd2dbfe96114062cea5455a01cb357",
        "54375f91d045705e6bb98ba5956cc3bff84560861f17e4a2b50ace7f8a794f43",
        "6c394d584f0dc942c3a68da882d169f0369bca9fb313e9e263300f15f6ccb88b",
        "417eb9f76e42713ffa4c16a582e432fbe614795a75dc5d103abafaac8980ad60",
        "1dd5642a02684cb52af71430290c888c624c949c34dd3a9917fc6873e9c706bf",
        "af52288c2278ba40cdf82a595657a25ba8b666febf8a3e053c0d27db189ca1e2",
        "4deffeffdcf4b06e8c7a5d1ec466bec9e76f1d059dac160ab36707d8952099ea",
        "a98d86ca75b05c7799fdf71261b666fab2ad3583f759ab4f1abd4b5e8557dacd",
        "007f99a288677865d93f93994bd9c5e66b2d871ebd7cb8078712149327e0c820",
        "3a660b3dacd8f30165e3aeb1ebccdb93574d3dc739aaac16c3835f2f4795aa47",
        "c5f6af4d844843e59ceffb7d7cab8dc379824b9f90d39b266219acf2f6710dcc",
        "bec0727562c3ac2651974d4bd5831dcc0063308ee14666a56dccedb5e1c78152",
        "d4b34fe251adba5d67b5a760eab9aa3153e1dab5762221306d55b1c51e58f888",
        "4f7834fab9e50502a3dd41f39094b8f2d0cb8691dba3d4eb06f8650282a2b96c",
        "0b1c6e440039554769bb3b2ed91f5705b1a7c1165a10216d703712422c3d3cb4"
      ],
      "sourceCharacterId": 387,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/game.swf",
      "sourceSha256": "41a8df7976f82b1bf476b6f2bd8c145a23eeabdfc2f8cf92f7172cee4ce1cbe4",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.gameFrostEffectAsset",
      "position": {
        "x": 0,
        "y": 24
      },
      "sourceFileFrameRate": 24,
      "loop": true,
      "headIconAtSourceFrame": null,
      "headIconPosition": null,
      "vectorFrameSha256": [
        "402e4619c9ae840162f846b6533d5185220aefa1fd7ab49b9a9f805f3c2c4b52",
        "524b5fc322497b53e4eea92d9c49188e83e648c60fd1e46844c2f3003cdb6be8",
        "882375beabeabb3818106eb5fc89a8321d27d34a257833e1c59f15bf540de35e",
        "725080328c94b149b8facc2d9dcb9de329667f7bcd82d1af90b9ab1c13787273",
        "36dbd792463aea0757e02094a97c4ac4addcdd8f6a30299963ec0f5441240831",
        "cb86f706ab45deacb88f97b40800d3bef0cb14eb55d8efd5c4c3cc5dd0464ca4",
        "1b90943a2576431c4d3db61065385d8314224f3fe633e27568936ddc89f96d55",
        "35d56683d396bed95b59b214235876fcf08ca70fc45b7e32b10ad3993822f538",
        "10d5b3053b3d06b48a8cb56c05aa4626f380b694f5e95dcbb5741339ac7274a5",
        "bf0f7ad10fae4da8100dbfe592ba8be9b988dd852ee2566da7b991284362983c",
        "480ac1b3606329498b8f986ae579d3fea4714409bae9abcb9097ae013cfa4a64",
        "cfd3f2645e4d5a4796df4103c47a1d2746cc2989abf7c02d59b61221b85d5368",
        "b6074e76a1dc9dbbf984dab90ed1678f0889368d237036e61195136bf3dc0f77",
        "d50ef7278ce2acb7c626697c36953cfc7f41f5f9683ae12d83ea7e25fce479a7",
        "7031a236d3d93daea1f47856196a877e3b7c185ab661a96fc45801e074dcdd1c",
        "13325c1bc7e90d5f7820509b8caff952c10949e4842708e84231d5c2989da314",
        "5e5a81532e2c060286296a91053e974a155d26423ef47e30957a38c10c06d5f6",
        "5f1d73c2065376764cd43631e802b7d0abfeddd74816a7652af7d9c36d9d5d83",
        "9f397b4d6040517e58a0e22ee078d88d8a4826d56e8a22e60902e2e05e62cdcf",
        "f82726edfdc187c044574d6b0f88459e7f5cebe4a1880f40aac3fc292432417c",
        "ae40c034d19203c68fa36d9b5f7c78816df78cb0911e26124696868926edd9a8",
        "3b68f52a7dcb3227473338b3d842b323440e000be81890631cb67aec254ad123",
        "634d6514acfc8e9b57af6335fc7e78833c313026d3664721dcc1538ceb9acd21",
        "513a6898bcb3df9337982db5711043543efa17cb3e2537d741f8879542d8e622",
        "240688627c23dca8a79ea572a637019e3d403f90413c38cc37d6f11e1e5228f5",
        "be0b5d2f57e04bc88ce7cfea84551cea2e80407ba23a4f58b7483537031faf11",
        "3351b8a1f97ece7d01da9c0651fdfaae225bad6d8269ad95c451feab1999276e",
        "699f6f2eadf9efc54559ee2280d475eedc782018114edc5bcf8974c5deb1a90c",
        "1e23ba3ca0ac844470a05bd67f14f1dea1423f980485b483afd036355e63b0d4",
        "ef3fffff195d0f564dbef2d34f76c6f4834a6838d90d59069cfd2e9edcdcd87b",
        "e2a4339cf8725b5147a770c3014ee8c4677b93adee268f0fd3a5db369abdf8e0",
        "bf3d607e4b7442fd50ac67843edb6ce1847d98058fa4266d9de2b194b6524103",
        "89cb64ad5a1dc2ba2475904aaef81eca75c416bc01f6dfcd4b376ddaa4b5bbdf",
        "4dd50f7f9c7f9b09bacf08e524953e01ad7ea810f9b7a615c0e7c55e963a7634",
        "abbb466e024ce6eb93c5fd97e843c7e1e77c99c363b9ea9341970c4a99a81189",
        "6b5d6a935a41c6d9126db324e63c1d4ee75b8039ca542ea5a0ba35e548b657b4",
        "46bc1690811ae3060f41e5fdcfbdf4e6fee01734ca4c30b32711bf4a688bae59",
        "4263ffe2ac0395d26f6e5284ccf36863840348d079e86dbc922c22c13cfd0977",
        "cf7878034fd35a94748fc8044bb993f59636e80063cff8a25038cd5a901c8562",
        "0228770e28ddfa222244088f8ab938bd9fe6d3f57cc93fb16f43650cd1f60bd5",
        "3664259cc33df8ba2a5363b42be26f6b961509632c655e2a910de01d78453468",
        "cba8b5e4ea5fd77c208ca37a4824d466a36779b01cfc4337b8e87b6ac1586c33",
        "829f552f382f3583ff167a3cc6b80623be3e1a412e6471f5e3380f3e62059aa7",
        "0b19a026d52fc3109fcb0ceb7553250e28e1c65d3d856fed50c89b7c0b99b52c",
        "9d1435f54a95815a9dfdc45a0294fc08749eab380490828b04b12ed1bce51e60",
        "e18e189780ee7379d261f8a00f7fde82570b9dcdace7e1a356044dc42bd9b0ae",
        "8ab27ad2c8eb5cbd8669a4d762be7f3c22f71244c25f460133372d4a1db8bc22",
        "5ba9e53c1711e614af3b93b8b152e346db0ac48ddcfedfcfdd6df846098110ee",
        "230f7a0174debb2d8980995df7429c26bf17213f0679d6b3cd7d4674891eaa36",
        "aaeaeaadd4efcbbcdbd82919ba57c5ece264791f165f996a2a0295873b73d434",
        "a0925984ea13fc60716b5e6060154e957290da9fdbece0ce51d5f2f1185b2ed3",
        "8aae87b17700a414640235a4b0585b152c5307aa7de5405ed2b08fa9675e104e",
        "312779d75144fd4aabf7069d8c4c5ee818dae8b98caf611436980520865b53cd",
        "20199546ca3a8be1733f1d511618a4f5fe48607b5e08b843501d3260b5970341",
        "c91a875c630536031bcacce7ed0e7677c941d53fd4a7946fd287665a82bc344b",
        "c70c1670d486baf1fd597a20417f61f61c8af880e37401c87450395eabc0641b",
        "23db08eecdc876d9afc4fa846d761adc6acdd2c1287418ac59a1c0884ceba9e3",
        "e0c85c2579f3d0e3b97d5f7df015c0f36d03cfa428258c171f44d865d2237938",
        "44c863c8628a68346e75f4315bb78e84ffa465ebc0161a9502e9e0fae6e8a20d",
        "1ced9ce97383a29b86b58da1ba4d1a71e7b19146808b90c5bf4cb84b55d98159",
        "71c9ca3666926fd4355d4650382aedfaa22b79b74d722c117f6dda64b2fec03f",
        "668917cae3f8d1adfd2c8274db052efcbececa5fd86d0768656b2b608c1ff0bb",
        "7a1223f7d27c3697a8cf3caea50a3a70e056827bef0c57c54364f8557c7b6c2d",
        "1c24883bd6aff316cc93820ab42a7a13f88cd39b2b9807b0db4e5d472ddaa4cf",
        "252284bc0d3da1a1ce231daaab807bef22f565a868b176e870a5df935c9b70a2",
        "7234f8651f9484c86f65fc657c6c04743cf61b37d7ec74ef74d300b926cb493a",
        "b1a9e9f5e49f7cbed0651b0f372e48c703f1f3325778123e4ad0e59061e74d84"
      ]
    }
  },
  "evidence": "Original archive pixels composed with original source face/faceUp order; source action arrays and prop symbols read statically. Exact2009 costumes/effect date unverified.",
  "usage": {
    "cry": "GamePlayer.__bloodChanged/getAction(cry): normal player damage uses CRY, not HIT.",
    "handclip": "GamePlayer.doUseItemAnimation calls handClipAction after039; allowed attack action may replace it per sourcePlayerAction rules.",
    "hit": "Original GameCharacter.HIT exported for completeness. No player damage call found; do not trigger it instead of sourceCRY.",
    "propAura": "GamePlayer.doUseItemAnimation places ghostPcikPropAsset at0,-10. Frame12 calls headPropEffect; separate actual prop/POW icon at-5,-140.",
    "lowHp": "STAND_LACK_HP uses StateLayer stateface and SpecialEffectsLayer textures absent from pinned legacy resource trees. Not substituted by normal idle or newly painted dark faces."
  },
  "rasterization": {
    "renderer": "@resvg/resvg-js",
    "version": "2.6.2",
    "sourceScale": 1,
    "derivation": "Original recovered SWF vector/bitmap paths rendered at original canvas dimensions to lossless RGBA PNG; no redraw or ActionScript execution."
  }
}
